import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CurrentCategory = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const { id } = useParams();

    const [name, setName] = useState("");
    const [parenId, setParentId] = useState(0);
    const [shopId, setShopId] = useState(0);
    const [dropBoxFolder, setDropBoxFolder] = useState("");
    const [description, setDescription] = useState("");
    const [sort, setSort] = useState("");

    const { data: category, refetch: refetchCategory } = useGetPageQuery("categories/" + id);
    const { data: categorySelect } = useGetPageQuery("categories/select");
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    useEffect(() => {
        if (category) {
            setName(category.title);
            setParentId(category.parent_id);
            setShopId(category.shop_id);
            setDropBoxFolder(category.dropbox_folder);
            setDescription(category.description);
            setSort(category.sort);
        }
    }, [category]);

    const sendFormHandler = async () => {
        const formData = {
            title: name,
            parent_id: parenId,
            shop_id: shopId,
            dropbox_folder: dropBoxFolder,
            description: description,
            sort: +sort,
        };

        await sendForm({ body: formData, url: "categories/" + id, method: "PUT" }).unwrap();
        await refetchCategory();

        if (!isError) {
            succsesDataChangeAlert();
            navigate("/categories");
        }
    };

    return (
        <>
            {category && categorySelect && (
                <div className="content">
                    <div id="content" className="content_card container-fluid">
                        <div className="col-12">
                            <div id="page-header">
                                <h1>{category.title}</h1>
                            </div>
                        </div>
                        <div className="form user_form">
                            <div className="col-12 col-sm-6 col-md-6">
                                <div className="card card-default">
                                    <div className="card-header d-flex justify-content-between">
                                        Параметри категорії
                                        {/* <div className="custom-control custom-checkbox float-right">
                                        <input type="checkbox" id="check_sync" name="sync" className="form-check-input" value="1" />
                                        <label className="form-check-label mx-1" for="check_sync">Синхронізувати</label>
                                    </div> */}
                                    </div>
                                    <div className="card-body">
                                        {/* <div className="custom-control custom-checkbox float-end">
                                        <input type="checkbox" id="check_imei" name="imei" className="form-check-input" value="1" />
                                        <label className="form-check-label mx-1" for="check_imei">Обов'язковий IMEI/SN</label>
                                    </div> */}
                                        <div className="form-group mb-3">
                                            <label className="form-label">Назва</label>
                                            <input
                                                type="text"
                                                className="form-control name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="form-label">Батьківська категорія</label>
                                            <select
                                                name="parent_id"
                                                className="form-select"
                                                placeholder="Батьківська категорія"
                                                onChange={(e) => setParentId(e.target.value)}
                                            >
                                                <option value="0">Батьківська категорія</option>
                                                {categorySelect.map((selectCategory) => {
                                                    return category.id !== selectCategory.id ? (
                                                        <option value={selectCategory.id} key={selectCategory.id}>
                                                            {"\u00A0\u00A0\u00A0\u00A0\u00A0".repeat(
                                                                selectCategory.level
                                                            ) + selectCategory.title}
                                                        </option>
                                                    ) : null;
                                                })}
                                            </select>
                                        </div>
                                        <div className="form-group mb-3">
                                            <label className="form-label">Порядковий номер</label>
                                            <input
                                                type="number"
                                                className="form-control name"
                                                value={sort}
                                                onChange={(e) => setSort(e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label className="form-label">ID категорії в магазині</label>
                                            <input
                                                type="text"
                                                className="form-control name"
                                                value={shopId}
                                                onChange={(e) => setShopId(e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group mb-3">
                                            <label className="form-label">Папка на Dropbox</label>
                                            <input
                                                type="text"
                                                name="name_db"
                                                className="form-control name"
                                                value={dropBoxFolder}
                                                onChange={(e) => setDropBoxFolder(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6">
                                <div className="card card-default">
                                    <div className="card-header">
                                        Опис
                                        {/* <div className="custom-control custom-checkbox float-end">
                                        <input type="checkbox" id="check_reports" name="reports" className="form-check-input" value="1" />
                                        <label className="form-check-label mx-1" for="check_reports">Відображати в звітах</label>
                                    </div> */}
                                    </div>
                                    <div className="card-body">
                                        <textarea
                                            className="form-control"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 clearfix">
                                {permissions.includes("category_edit") || permissions.includes("all") ? (
                                    <div className="saves_block">
                                        <button className="btn btn-primary" onClick={sendFormHandler}>
                                            {isLoading ? "Завантаження" : "Зберегти"}
                                        </button>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentCategory;
